import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { setCoachingfeedBacks } from "../../../../reducer/mediumSlice";
import { setLoading } from "../../../../reducer/auth/auth";
import { getPracticeFeedbacks, publishFeedback } from "../../../../services/medium";
import InfoPopup from "../../../../components/infopopup";
import FeedBackTimeBox from "../subcomponents/feedbacktimebox";
import Button from "../../../../components/button";
import "../index.css";
// import "./feedback.css";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function GroupCoachingFeedback() { 
  const { t } = useTranslation("mediumFeedbacks");
  const { coachingfeedBacks } = useSelector((state) => state.medium);
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState(0);
  const [localFeedBacks, setLocalFeedBacks] = useState([]);
  const [active, setActive] = useState({});
  const [publishActiveItem, setPublishActiveItem] = useState()
  const [sessionType, setSessionType] = useState([])
  const [localFeedBacksstatus, setLocalFeedBacksstatus] = useState([]);


  useEffect(() => {
    callBack();
    if (!coachingfeedBacks.length) callBack();
  }, []);
  useEffect(() => {
    let info = coachingfeedBacks.map((data) => {
      return false;

    })
    setLocalFeedBacksstatus(info);
    setLocalFeedBacks(coachingfeedBacks);
  }, [coachingfeedBacks]);

  function groupBy(objectArray, property) {
    const grouped = new Map();
    
    objectArray.forEach((item) => {
        const key = item[property];
        if (!grouped.has(key)) {
            grouped.set(key, []);
        }
        grouped.get(key).push(item);
    });
    
    // Convert Map to array of arrays, maintaining order
    return Array.from(grouped.values());
  }

  const callBack = () => {
     const subsession_table = [
  parseInt(process.env.REACT_APP_COACHING_GROUP_SESSION_ID),
  94
];
    getPracticeFeedbacks(2, subsession_table.join(","))
      .then((data) => {
        if (data.data.status) {

          let info = []

          if (typeof (info) === 'object') {
            const propertyValues = Object.values(data.data.data);
            info = propertyValues.map((feed) => {
              delete feed.feedback['about_verysoul'];
              delete feed.feedback['anything_else'];
              return feed;
            })
          }
          else {
            info = data.data.data.map((feed) => {
              delete feed.feedback['about_verysoul'];
              delete feed.feedback['anything_else'];
              return feed;
            })
          }
          let grouped = groupBy(info, "appointment");
          // let array = [];
          let obj = Object.values(grouped).map((val) => {
            return Object.assign({}, val);
          });
          dispatch(setCoachingfeedBacks(obj));
        }
      })
      .catch(() => { });
  };

  const openMoreInfo = (info) => {
    let array = []; 
    var feedback = info && info[0].feedback? info[0].feedback : "";
    var dataSession =  info;
    setSessionType(dataSession);
    if(feedback){
      const arrayData = Object.keys(dataSession).map(key => dataSession[key]);
      setSessionType(arrayData);
      array =[ {
        [t("coachingQuestions.wantOthersToKnow")] : feedback && feedback.answer_1 ? feedback.answer_1 : "" ,
        [t("coachingQuestions.word1")]: feedback && feedback.answer_21 ? feedback.answer_21 : "",
        [t("coachingQuestions.word2")]: feedback && feedback.answer_22 ? feedback.answer_22 : "",
        [t("coachingQuestions.word3")]: feedback && feedback.answer_23 ? feedback.answer_23 : "",
        [t("coachingQuestions.sessionHelped")]: feedback && feedback.answer_3 ? feedback.answer_3 : "",
        [t("coachingQuestions.privateMessage")]: feedback && feedback.answer_4 ? feedback.answer_4 : "",
      }];
      setActive(array);
      window.loadModal2("#infopopup", "show");
    }
  };
  const updatePublishStatus = (id, status, duration = "") => {
    dispatch(setLoading(true));
    let body = {
      feedback_id: id,
      status: status,
      // duration: duration,
    };
    publishFeedback(body)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status && status === 0) {

          toast.success(t("toast.considered"), {
            position: "top-center",
          });

        }
        if (data.data.status && status === 1) {
          window.loadModal2("#feedbacktimebox", "hide");
          toast.success(t("toast.publishRequested"), {
            position: "top-center",
          });

        }
        callBack()
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const openApproveContainer = (item) => {
    setPublishActiveItem(item);
    window.loadModal2("#feedbacktimebox", "show");
  };
  const onClickHandler = (e, index) => {
    let info = localFeedBacksstatus.map((data, i) => {
      if (i === index) {
        return !data;
      }
      else {
        return false;
      }
    })

    setLocalFeedBacksstatus(info);
  }
  return (
    <>
      <div className="dashboard">
        <div className="row">
          <div className="col-md-12">
            <div className="my-ppointments-box appoint-das">
              <div className="table-box-medium admin-feed-page">
                <table className="caseTable">
                  <tbody>
                    <tr className="dark">
                      <th>{t("table.sessionNumber")}</th>
                      <th>{t("table.clientName")}</th>
                      <th>{t("table.feedback")}</th>
                      <th>{t("table.reviewStatus")}</th>
                      <th>{t("table.sessionDate")}</th>
                      <th>{t("table.sessionTime")}</th>
                      <th>{t("table.surveyDate")}</th>
                      <th>{t("table.status")}</th>
                    </tr>
                    {localFeedBacks.length > 0 ? (
                      localFeedBacks.map((item, index) => (
                        <tr className="innr">
                          <td>{item[0].front_appointment_id}</td>
                          <td className="">{item[0].client_name}</td>
                          <td className=""><button 
                            className="font-size-14 mr-3 pointer learn-more-btn btnView"
                            onClick={() => openMoreInfo(item)}
                          >
                            {t("actions.view")}
                          </button></td>
                          <td className="color-gray">
                          <div className="">
                                {item[0] && item[0].status === 0 && item[0].feedback_id ? (
                                  <select 
                                    className="appointment-select-box"
                                    onChange={(e) => updatePublishStatus(item[0].feedback_id, parseInt(e.target.value), "")}
                                    defaultValue=""
                                    disabled={true}
                                  >
                                    <option value="" disabled>{t("actions.select")}</option>
                                    <option value="1">{t("actions.approve")}</option>
                                    <option value="2">{t("actions.consider")}</option>
                                  </select>
                                ) : (
                                  <>{t("actions.noActions")}</>
                                )}
                           
                            
                                {/* {item[0].status !== 0 && <span
                                 onClick={() =>
                                  updatePublishStatus(item[0].feedback_id, 3, "")
                                }
                                >
                                  Request Review
                                </span>} */}
                                

                              </div>
                          </td>
                          <td className="">
                            {moment(item[0].session_date).format("LL")}
                          </td>
                          <td className="">
                            {/* {item[0].session_time} */}
                            {moment(item[0].session_time, ["h:mm A"]).format(
                              "hh:mm a"
                            )}
                          </td>
                          {/* <td className="">{item[0].session_type}</td> */}
                          
                          <td>
                            {moment(item[0].date).format("LL")}
                          </td>
                          <td className="color-gray">
                            {item[0].status === 0 ? t("status.pending") : item[0].status === 1 ? t("status.approved") : t("status.considered")}
                          </td>

                          {/********** */}
                          {/* <td className="feedBack-action-box-medium">
                            <Button
                              className={`resend-btn w-unset height-35 min-width-130px`}
                              title="Approve"
                              status={0}
                              onClick={() => updatePublishStatus(item[0].feedback_id, 1, "")}
                            />
                            <Button
                              className={`resend-btn w-unset height-35 min-width-130px`}
                              title="Consider"
                              status={0}
                              onClick={() =>
                                updatePublishStatus(item[0].feedback_id, 0, "")
                              }
                            />
                            <img
                              title="More"
                              onClick={() => openMoreInfo(item)}
                              className="pointer"
                              src="/localImages/openeye.svg"
                              alt="eye"
                            />
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center">
                          {t("empty.noFeedbacks")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <InfoPopup feedBackinfo={active} sessionType={sessionType}/>
        <FeedBackTimeBox publishMediumFeedback={updatePublishStatus} info={publishActiveItem} />
      </div>
    </>
    // <div className="all-medium-page">
    //   <Tabs list={list} setActiveTab={setActiveTab} />
    //   <ul className="tabs-content">
    //     <TabPanel id={0} activeTab={activeTab}>
    //       <IntermediateFeedback />
    //     </TabPanel>
    //     <TabPanel id={1} activeTab={activeTab}>
    //       <PartnerFeedback />
    //     </TabPanel>
    //     <TabPanel id={2} activeTab={activeTab}>
    //       <ProfessionalFeedback />
    //     </TabPanel>
    //   </ul>
    // </div>
  );
}